module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc01"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Other two-in-one Westerns from Cameron Judd")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Devil Wire")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Brazos")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Quest of Brady Kenton")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kenton’s Challenge")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Timber Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Renegade Lawmen")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Snow Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Corrigan")])]), _vm._v(" "), _c('p', {
    staticClass: "adCardText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Available from St. Martin's Paperbacks")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41df0fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312943349_adc01.vue
// module id = 63
// module chunks = 0